import {
  ADD_POLICIES_TO_LIST,
  CLEAR_POLICIES,
  DELETE_POLICIES_FROM_LIST,
  EDIT_POLICIES_IN_LIST,
  SET_POLICIES,
} from '../types/policies-types';

import { policiesInitialState } from 'store/initial-states/policies-initial-state';

export const policiesReducer = (state = policiesInitialState, action) => {
  switch (action.type) {
    case SET_POLICIES:
      return action.payload;

    case ADD_POLICIES_TO_LIST:
      return [...state.policies, action.payload];

    case EDIT_POLICIES_IN_LIST:
      return state.policies.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload.updatedData } : item
      );

    case DELETE_POLICIES_FROM_LIST:
      return state.policies.filter((item) => item.id !== action.payload);

    case CLEAR_POLICIES:
      return policiesInitialState;

    default:
      return state;
  }
};
